export default __webpack_public_path__ + "static/media/PSO.88910d28.png";